import React from 'react';
import './Skeleton.css';

export function Skeleton({ width = '100%', height = 14, radius = 6, className = '' }) {
  return <span className={`skeleton ${className}`} style={{ width, height, borderRadius: radius }} aria-hidden="true" />;
}

// Placeholder shaped like a bet / challenge card
export function SkeletonBetCard({ rows = 1 }) {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton-card-header">
        <Skeleton width={120} height={12} />
        <Skeleton width={64} height={20} radius={999} />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div className="skeleton-card-row" key={i}>
          <Skeleton width={32} height={32} radius={8} />
          <div className="skeleton-card-lines">
            <Skeleton width="45%" height={13} />
            <Skeleton width="30%" height={11} />
          </div>
          <Skeleton width={40} height={16} />
        </div>
      ))}
      <div className="skeleton-card-footer">
        <Skeleton width="60%" height={12} />
        <Skeleton width="60%" height={12} />
        <Skeleton width="60%" height={12} />
      </div>
    </div>
  );
}

export function SkeletonStats({ count = 4 }) {
  return (
    <div className="skeleton-stats" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div className="skeleton-stat" key={i}>
          <Skeleton width="50%" height={12} />
          <Skeleton width="70%" height={24} />
        </div>
      ))}
    </div>
  );
}

// A full-page loading placeholder: stat tiles followed by a few cards
export function SkeletonBetList({ cards = 3, stats = true }) {
  return (
    <div className="skeleton-page" role="status" aria-label="A carregar">
      {stats && <SkeletonStats />}
      {Array.from({ length: cards }).map((_, i) => (
        <SkeletonBetCard key={i} rows={i === 1 ? 2 : 1} />
      ))}
    </div>
  );
}
